import AlarmSetting from './pages/AlarmSetting';
import Laboratory from './pages/Laboratory';
import PointOfContact from './pages/PointOfContact';
import type { ScreenItem } from 'shared/src/types';

export const MyPageScreens: ScreenItem[] = [
  {
    name: 'AlarmSetting',
    component: AlarmSetting,
    path: '/mypage/alarm-setting',
    options: {
      title: '알림 설정',
    },
  },
  {
    name: 'Laboratory',
    component: Laboratory,
    path: '/mypage/laboratory',
    options: {
      title: '실험실',
    },
  },
  {
    name: 'PointOfContact',
    component: PointOfContact,
    path: '/mypage/point-of-contact',
    options: {
      title: '상담 그룹 등록',
    },
  },
];
